// extracted by mini-css-extract-plugin
export var containerLarge = "index-module--containerLarge--25Ycs";
export var stepsItem = "index-module--stepsItem--2_c1S";
export var stepCircle = "index-module--stepCircle--1fgY5";
export var innerTextLink = "index-module--innerTextLink--1diPk";
export var boxMethodology = "index-module--boxMethodology--1F4ZS";
export var methodology = "index-module--methodology--3dl4T";